import React from "react";
import MainLayout from "../../components/common/layout/main/MainLayout";
import withAuth from "../../hocs/withAuth";

function HomePage() {
  return (
    <MainLayout>
      <div>Báo cáo tổng hợp KQTT</div>
    </MainLayout>
  );
}

export default withAuth(HomePage);
